<template>
  <b-form-group>
    <template v-slot:label>
      CPF: 
      <span v-if="validadoreceita" style="background-color: #f3f6f9; padding: 4px 4px; margin-left: 5px; border-radius: 6px;">
        <img src="media/icons/valid.png" style="width: 24px; margin-bottom: 2px;" /> Validado
      </span>
      <a
        v-if="!validadoreceita"
        href="javascript:;"
        @click="validarCPFReceita"
        class="btn btn-light-primary font-weight-bolder mr-2"
        :disabled="loading" 
        style="margin: 0; padding: 0px 4px; font-size: 10px; margin-left: 4px;"
      >
        <b-spinner
          v-if="loading"
          small
          style="margin-bottom: 2px; margin-right: 3px;"
        ></b-spinner>
        <i v-if="!loading" class="ki ki-check icon-sm"></i> Validar Receita
      </a>
    </template>
    <b-form-input
      type="text"
      v-model="valor"
      placeholder="CPF"
      v-mask="'###.###.###-##'"
      :state="valid"
      @blur="validar"
    ></b-form-input>
    <b-form-invalid-feedback>
      O CPF informado não é válido.
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<style lang="scss" scoped></style>

<script>
import Swal from "sweetalert2";
import moment from "moment";

export default {
  name: "InputCPF",
  data() {
    return {
      valid: null,
      loading: false
    };
  },
  computed: {
    valor: {
      get: function() {
        return this.value;
      },
      set: function(newValue) {
        this.$emit("input", newValue);
      }
    }
  },
  props: ["value", "validadoreceita", "datanascimento"],
  methods: {
    validar() {
      let cpf = this.valor.replace(/[^\d]+/g, "");

      this.valid = null;

      if (cpf == "") this.valid = false;

      if (
        cpf.length != 11 ||
        cpf == "00000000000" ||
        cpf == "11111111111" ||
        cpf == "22222222222" ||
        cpf == "33333333333" ||
        cpf == "44444444444" ||
        cpf == "55555555555" ||
        cpf == "66666666666" ||
        cpf == "77777777777" ||
        cpf == "88888888888" ||
        cpf == "99999999999"
      )
        this.valid = false;

      let add = 0;
      let i = 0;

      for (i = 0; i < 9; i++) add += parseInt(cpf.charAt(i)) * (10 - i);

      let rev = 11 - (add % 11);

      if (rev == 10 || rev == 11) rev = 0;

      if (rev != parseInt(cpf.charAt(9))) this.valid = false;

      add = 0;

      for (i = 0; i < 10; i++) add += parseInt(cpf.charAt(i)) * (11 - i);

      rev = 11 - (add % 11);

      if (rev == 10 || rev == 11) rev = 0;

      if (rev != parseInt(cpf.charAt(10))) this.valid = false;

      if (this.valid == null) this.valid = true;

      return this.valid;
    },
    async validarCPFReceita() {
      if((this.validar()) && (this.datanascimento)) {
        this.loading = true;

        let retorno = await this.$store.dispatch("getCPFCaptcha", {});
        let resultadoValidacao = {};

        await Swal.fire({
          imageUrl: retorno.captcha,
          title: 'Confirme o captcha:',
          input: 'text',
          inputAttributes: {
            autocapitalize: 'off'
          },
          showCancelButton: false,
          confirmButtonText: 'Enviar',
          showLoaderOnConfirm: true,
          preConfirm: (captcha) => {
            return this.$store.dispatch("getCPFValidacao", {
              cpf: this.valor.replace(/\D/g, ""),
              dataNascimento: moment(this.datanascimento).format("YYYY-MM-DD"),
              captcha: captcha,
              session: retorno.PHPSESSID
            }).then(response => {
              resultadoValidacao = response;
            });
          },
          allowOutsideClick: () => !Swal.isLoading()
        });

        this.loading = false;

        if(resultadoValidacao.status == "OK") {
          Swal.fire({
            title: "Aviso",
            text: "Emitente validado com sucesso.",
            icon: "success",
            timer: 3000,
            showConfirmButton: false
          });

          this.$emit("validacaoReceitaCPF", resultadoValidacao);
        } else {
          Swal.fire({
            title: "Aviso",
            text: "Não foi possível validar. Tente novamente mais tarde.",
            icon: "error",
            timer: 3000,
            showConfirmButton: false
          });
        }
      } else {
        Swal.fire({
          title: "Aviso",
          text: "O CPF informado não é válido ou não foi informada a data de nascimento.",
          icon: "error",
          timer: 3000,
          showConfirmButton: false
        });
      }
    }
  }
};
</script>
